import { render } from "./CommentItemDIY.vue?vue&type=template&id=5c4030be&scoped=true"
import script from "./CommentItemDIY.vue?vue&type=script&lang=js"
export * from "./CommentItemDIY.vue?vue&type=script&lang=js"

import "./CommentItemDIY.vue?vue&type=style&index=0&id=5c4030be&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c4030be"]])

export default __exports__